import { extraRoutes, navEntries } from './registry';

export const APP_NAME = 'Restaurant POS';

const FIXED: Record<string, string> = {
  '/login': 'Sign in',
  '/change-password': 'Change password',
};

/** Human title of a route (no app name). Unknown paths are "Page not found". */
export function pageTitleFor(pathname: string): string {
  const path = pathname.replace(/\/+$/, '') || '/';
  if (FIXED[path]) return FIXED[path];
  if (path === '/') return navEntries[0]?.label ?? APP_NAME;
  const match = [...navEntries, ...extraRoutes.map((r) => ({ path: r.path, label: r.screen }))]
    .filter((e) => path === e.path || path.startsWith(`${e.path}/`))
    .sort((a, b) => b.path.length - a.path.length)[0];
  return match ? match.label : 'Page not found';
}

export function documentTitleFor(pathname: string): string {
  return `${pageTitleFor(pathname)} · ${APP_NAME}`;
}
